import React, { useState } from "react";
import { Col, Row, Offcanvas } from "react-bootstrap";
import styles from "./Portfolio.module.css";
import DataTable from "../../Common/DataTable/DataTable";
import { bigDecimal } from "js-big-decimal";
import { Button } from "../../Common";
import { clearPortfolio, regeneratePortfolio } from "../../api";
import { PortfolioMessages } from "../../Constants/Messages";

function Stack({ stack, custId, refreshPortfolio, featureAccess }) {
  const [showStocksCanvas, setShowStocksCanvas] = useState(false);
  const [selectedStackStocks, setSelectedStackStocks] = useState([]);
  const [message, setMessage] = useState("");
  const [regenerateLoading, setRegenerateLoading] = useState(false);
  const [clearLoading, setClearLoading] = useState(false);
  const [activeSymbol, setActiveSymbol] = useState(null);

  const stackColums = [
    "Stack",
    "Name",
    "Total Invested",
    "View Stocks",
    "",
    "",
    "",
  ];
  const refreshData = async () => {
    try {
      if (refreshPortfolio) {
        await refreshPortfolio();
      }
    } catch (error) {
      setMessage("Error refreshing portfolio data:", error);
    }
  };
  const regenerateButton = async (symbol) => {
    try {
      setRegenerateLoading(true);
      setActiveSymbol(symbol);
      const response = await regeneratePortfolio(custId, "stack", symbol);

      if (response && response.code === 200) {
        setMessage(PortfolioMessages.ProcessInitiated);
        setTimeout(async () => {
          await refreshData();
          setRegenerateLoading(false);
          setActiveSymbol(null);
          setTimeout(() => setMessage(""), 2000);
        }, 1000);
      } else {
        setMessage(response.data.message);
        setRegenerateLoading(false);
        setActiveSymbol(null);
        setTimeout(() => setMessage(""), 3000);
      }
    } catch (error) {
      setMessage(PortfolioMessages.RegenerateFailed);
      setRegenerateLoading(false);
      setActiveSymbol(null);
      setTimeout(() => setMessage(""), 3000);
    }
  };
  const clearButton = async (symbol) => {
    try {
      setClearLoading(true);
      setActiveSymbol(symbol);
      const response = await clearPortfolio(custId, "stack", symbol);

      if (response && response.code === 200) {
        setMessage(response.data.results);
        setTimeout(async () => {
          await refreshData();
          setClearLoading(false);
          setActiveSymbol(null);
          setTimeout(() => setMessage(""), 2000);
        }, 1000);
      } else {
        setMessage(response.data.message);
        setClearLoading(false);
        setActiveSymbol(null);
        setTimeout(() => setMessage(""), 3000);
      }
    } catch (error) {
      setMessage(PortfolioMessages.ClearFailed);
      setClearLoading(false);
      setActiveSymbol(null);
      setTimeout(() => setMessage(""), 3000);
    }
  };

  const addCommasInPrice = (price, decimal = true) => {
    if (typeof price === "string") {
      const cleanedPrice = price.replace(/[^\d.]/g, "");
      if (!isNaN(cleanedPrice)) {
        return parseFloat(cleanedPrice).toLocaleString("en-US", {
          maximumFractionDigits: decimal ? 2 : 0,
        });
      }
    } else if (!isNaN(price)) {
      return parseFloat(price).toLocaleString("en-US", {
        maximumFractionDigits: decimal ? 2 : 0,
      });
    }
    return price;
  };

  const calculatePrice = (totalInvestment, units) => {
    if (
      !totalInvestment ||
      !units ||
      totalInvestment === "--" ||
      units === "--"
    ) {
      return "--";
    }

    try {
      const investment = new bigDecimal(totalInvestment);
      const totalUnits = new bigDecimal(units);

      if (totalUnits.getValue() === "0") {
        return "--";
      }

      const price = investment.divide(totalUnits, 2);
      return addCommasInPrice(price.getValue());
    } catch (error) {
      return "--";
    }
  };

  const getPrice = (item) => {
    if (item.averagePrice && item.averagePrice !== "--") {
      return addCommasInPrice(item.averagePrice);
    }
    return calculatePrice(item.totalInvestment, item.qty);
  };

  const stocksColumns = [
    {
      Header: "Ticker",
      accessor: "ticker",
      search: false,
    },
    {
      Header: "Units",
      accessor: "qty",
      search: false,
    },
    {
      Header: "Avg Price",
      accessor: "averagePrice",
      Cell: ({ row }) => {
        return <span>{getPrice(row.original)}</span>;
      },
    },
    {
      Header: "Total Investment",
      accessor: "totalInvestment",
      search: false,
    },
  ];

  const handleViewStocks = (stackData) => {
    setSelectedStackStocks(stackData.stocks || []);
    setShowStocksCanvas(true);
  };
  return (
    <>
      {message && (
        <div
          style={{
            margin: "10px",
            padding: "10px",
            backgroundColor: "#ddffdd",
            borderRadius: "4px",
          }}
        >
          {message}
        </div>
      )}

      <Row style={{ margin: "10px 10px" }}>
        {stackColums.map((item, index) => (
          <Col key={index} className={styles.stockHeading}>
            {item}
          </Col>
        ))}
      </Row>

      {stack.length !== 0 ? (
        stack.map((item, index) => (
          <Row key={index} className={styles.stockRow} style={{ margin: "10px 10px" }}>
            <Col className={styles.stockTitle}>{item.ticker || "--"}</Col>
            <Col className={styles.stockTitle}>
              <span className={styles.stockTitleTruncate} title={item.name}>
                {item.name || "--"}
              </span>
            </Col>
            <Col className={styles.stockTitle}>
              {item.totalInvestment || "--"}
            </Col>
            <Col>
              <Button
                title="View Allocations"
                margin={"0px 0px"}
                onClick={() => handleViewStocks(item)}
                classes={styles.viewButton}
              />
            </Col>
            <Col className={styles.stockTitle}></Col>
            <Col>
            {featureAccess?.writeAccess && (
                <Button
                  title="Regenerate"
                  margin={"0px 10px"}
                  onClick={() => regenerateButton(item.symbol)}
                  loading={regenerateLoading && activeSymbol === item.symbol}
                />
              )}
            </Col>
            <Col>
              {featureAccess?.writeAccess && (
              <Button
                title="Clear"
                margin={"0px 10px"}
                onClick={() => clearButton(item.symbol)}
                loading={clearLoading && activeSymbol === item.symbol}
              />
            )}
            </Col>
          </Row>
        ))
      ) : (
        <Row style={{ margin: "10px 10px", textAlign: "left", color: "gray" }}>
          <Col colSpan={stackColums.length}>
            <span>No data found</span>
          </Col>
        </Row>
      )}
      <Offcanvas
        show={showStocksCanvas}
        onHide={() => setShowStocksCanvas(false)}
        placement="end"
        className={styles.offcanvas}
        backdropClassName={styles.backgroundBlur}
        style={{ color: "white" }}
      >
        <Offcanvas.Header
          closeButton
          style={{
            backgroundColor: "#343434",
            color: "white",
            fontSize: "15px",
            height: "50px",
          }}
        >
          <Offcanvas.Title>Stack Stocks Details</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className={styles.tableBody}>
          {selectedStackStocks.length > 0 ? (
            <DataTable
              columns={stocksColumns}
              list={selectedStackStocks}
              rowClick={false}
              className={styles.dataTable}
            />
          ) : (
            <p
              style={{
                color: "white",
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              No Stocks Found
            </p>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Stack;
